<!-- Wrapper Body -->
<div class="wrapper-body" *ngIf="show">
    <div class="align-items-md-center d-flex flex-column flex-md-row page-header">
        <h3>{{apptDetails.parentDetails.studentFirstName}} {{apptDetails.parentDetails.studentLastName}} Assessment</h3>
        <a href="javascript:Void(0)" data-target="#viewDocumentsModal" data-toggle="modal"
            class="ml-auto ml-2 theme-button green">View Documents</a>
        <a [routerLink]="['/appt-all-details',apptDetails.appointmentDetails.appointmentId]"
            class="grey ml-3 theme-button">Back</a>
    </div>

    <div id="studentObservationForm" class="custom-form">
        <div class="row">
            <!-- Survey Detail -->
            <div class="col-md-6">
                <div class="card">
                    <h5 class="mb-0 text-purple">Surveys to be performed</h5>
                    <hr>
                    <div class="row">
                        <div class="col-12">
                            <div class="d-flex flex-wrap"
                                *ngIf="apptDetails.appointmentDetails.schedules[0].assesmentSurvey.length>0">
                                <p class="badge badge-pill bg-purple-light mr-2  px-3 py-2"
                                    *ngFor="let survey of apptDetails.appointmentDetails.schedules[0].assesmentSurvey">
                                    {{survey.name}}</p>
                            </div>
                            <div class="d-flex flex-wrap"
                                *ngIf="apptDetails.appointmentDetails.schedules[0].assesmentSurvey.length==0">
                                <p class="text-warning mr-2  px-3 py-2">
                                    No Survey Selected</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Test Detial -->
            <div class="col-md-6">
                <div class="card">
                    <h5 class="mb-0 text-purple">Tests to be performed</h5>
                    <hr>
                    <div class="row">
                        <div class="col-12">
                            <div class="d-flex flex-wrap"
                                *ngIf="apptDetails.appointmentDetails.schedules[0].assesmentTest.length>0">
                                <p class="badge badge-pill bg-purple-light mr-2 px-3 py-2"
                                    *ngFor="let test of apptDetails.appointmentDetails.schedules[0].assesmentTest">
                                    {{test.name}}
                                </p>
                            </div>
                            <div class="d-flex flex-wrap"
                                *ngIf="apptDetails.appointmentDetails.schedules[0].assesmentTest.length==0">
                                <p class="text-warning mr-2  px-3 py-2">
                                    No Tests Selected</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Test Notes -->
            <div *ngIf="testSurveyComment.length>0"
                class="col-md-12">
                <div class="card">
                    <h5 class="mb-0 text-purple">Testing Notes</h5>
                    <hr>
                    <div class="row">
                        <div class="col-12">

                            <textarea name="testSurveyComment" [(ngModel)]="testSurveyComment" readonly="trues" rows="4"
                                class="custom-input" placeholder="Other Comments"></textarea>

                        </div>
                    </div>
                </div>
            </div>

            <!-- Student Observation Form -->
            <div class="col-12">
                <div class="card">
                    <h5 class="mb-0 text-purple">Observation Form</h5>
                    <hr>

                    <div [formGroup]="studentObservationTest">
                        <div class="row pt-1 px-3">
                            <div class="col-lg-3 col-md-6 pt-2">
                                <div class="mb-2">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" formControlName="bouncingLeg"
                                            class="custom-control-input">
                                        <label class="custom-control-label" for="bouncingLeg">Bouncing leg</label>
                                    </div>
                                </div>
                                <div class="mb-2">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" formControlName="tappingPencil"
                                            class="custom-control-input">
                                        <label class="custom-control-label" for="tappingPencil">Tapping pencil</label>
                                    </div>
                                </div>
                                <div class="mb-2">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" formControlName="playingWithPencil"
                                            class="custom-control-input">
                                        <label class="custom-control-label" for="playingWithPencil">Playing with
                                            pencil</label>
                                    </div>
                                </div>
                                <div class="mb-2">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" formControlName="pickingIPad"
                                            class="custom-control-input">
                                        <label class="custom-control-label" for="pickingIPad">Picking at iPad</label>
                                    </div>
                                </div>
                                <div class="mb-2">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" formControlName="upPermission"
                                            class="custom-control-input">
                                        <label class="custom-control-label" for="upPermission">Up w/o
                                            permission</label>
                                    </div>
                                </div>
                                <div class="mb-2">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" formControlName="difficultySitting"
                                            class="custom-control-input">
                                        <label class="custom-control-label" for="difficultySitting">Difficulty
                                            sitting</label>
                                    </div>
                                </div>
                                <div class="mb-2">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" formControlName="chewingClothing"
                                            class="custom-control-input">
                                        <label class="custom-control-label" for="chewingClothing">Chewing on
                                            clothing</label>
                                    </div>
                                </div>
                                <div class="mb-2">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" formControlName="playingWithHair"
                                            class="custom-control-input">
                                        <label class="custom-control-label" for="playingWithHair">Playing with
                                            hair</label>
                                    </div>
                                </div>
                                <div class="mb-2">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" formControlName="playingWithJewelry"
                                            class="custom-control-input">
                                        <label class="custom-control-label" for="playingWithJewelry">Playing with
                                            jewelry</label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6 pt-2">
                                <div class="mb-2">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" formControlName="shufflingFeet"
                                            class="custom-control-input">
                                        <label class="custom-control-label" for="shufflingFeet">Shuffling feet</label>
                                    </div>
                                </div>
                                <div class="mb-2">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" formControlName="noisesWithMouth"
                                            class="custom-control-input">
                                        <label class="custom-control-label" for="noisesWithMouth">Noises with
                                            mouth</label>
                                    </div>
                                </div>
                                <div class="mb-2">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" formControlName="humming" class="custom-control-input">
                                        <label class="custom-control-label" for="humming">Humming</label>
                                    </div>
                                </div>
                                <div class="mb-2">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" formControlName="clickingOfTongue"
                                            class="custom-control-input">
                                        <label class="custom-control-label" for="clickingOfTongue">Clicking of
                                            tongue</label>
                                    </div>
                                </div>
                                <div class="mb-2">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" formControlName="impulsiveResponses"
                                            class="custom-control-input">
                                        <label class="custom-control-label" for="impulsiveResponses">Impulsive
                                            responses</label>
                                    </div>
                                </div>
                                <div class="mb-2">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" formControlName="excessiveTalking"
                                            class="custom-control-input">
                                        <label class="custom-control-label" for="excessiveTalking">Excessive
                                            Talking</label>
                                    </div>
                                </div>
                                <div class="mb-2">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" formControlName="rushesThroughTasks"
                                            class="custom-control-input">
                                        <label class="custom-control-label" for="rushesThroughTasks">Rushes through
                                            tasks</label>
                                    </div>
                                </div>
                                <div class="mb-2">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" formControlName="playingWithClothes"
                                            class="custom-control-input">
                                        <label class="custom-control-label" for="playingWithClothes">Playing with
                                            clothes</label>
                                    </div>
                                </div>
                                <div class="mb-2">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" formControlName="needsFrequentRedirect"
                                            class="custom-control-input" value="Needs frequent redirect">
                                        <label class="custom-control-label" for="needs-frequent-redirect">Needs frequent
                                            redirect</label>
                                    </div>
                                </div>
                            </div>

                            <!--  -->

                            <div [formGroup]="studentObservation" class="col-lg-6 px-0">
                                <div class="rounded bg-theme-light px-3 pt-2">
                                    <div class="d-flex border-bottom justify-content-between">
                                        <small class="py-1 mr-3">Adequate pencil grasp?</small>
                                        <div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="adequate-pencil-yes"
                                                    formControlName="pencilGrasp" class="custom-control-input" value=1>
                                                <label class="custom-control-label"
                                                    for="adequate-pencil-yes">Yes</label>
                                            </div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="adequate-pencil-no"
                                                    formControlName="pencilGrasp" class="custom-control-input" value=2>
                                                <label class="custom-control-label" for="adequate-pencil-no">No</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex border-bottom justify-content-between">
                                        <small class="py-1 mr-3">Holds paper with other hand when writing?</small>
                                        <div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="holds-paper-yes" formControlName="holdsPaper"
                                                    class="custom-control-input" value=1>
                                                <label class="custom-control-label" for="holds-paper-yes">Yes</label>
                                            </div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="holds-paper-yes" formControlName="holdsPaper"
                                                    class="custom-control-input" value=2>
                                                <label class="custom-control-label" for="holds-paper-no">No</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex border-bottom justify-content-between">
                                        <small class="py-1 mr-3">More than one snack break?</small>
                                        <div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="more-snac-break-yes"
                                                    formControlName="moreSnackBreak" class="custom-control-input"
                                                    value=1>
                                                <label class="custom-control-label"
                                                    for="more-snac-break-yes">Yes</label>
                                            </div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="more-snac-break-no"
                                                    formControlName="moreSnackBreak" class="custom-control-input"
                                                    value=2>
                                                <label class="custom-control-label" for="more-snac-break-no">No</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex border-bottom justify-content-between">
                                        <small class="py-1 mr-3">More than one bathroom break?</small>
                                        <div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="more-bathroom-break-yes"
                                                    formControlName="moreBathroomBreak" class="custom-control-input"
                                                    value=1>
                                                <label class="custom-control-label"
                                                    for="more-bathroom-break-yes">Yes</label>
                                            </div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="more-bathroom-break-no"
                                                    formControlName="moreBathroomBreak" class="custom-control-input"
                                                    value=2>
                                                <label class="custom-control-label"
                                                    for="more-bathroom-break-no">No</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex border-bottom justify-content-between">
                                        <small class="py-1 mr-3">Frequently responded with IDK</small>
                                        <div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="idk-yes" formControlName="idk"
                                                    class="custom-control-input" value=1>
                                                <label class="custom-control-label" for="idk-yes">Yes</label>
                                            </div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="idk-no" formControlName="idk"
                                                    class="custom-control-input" value=2>
                                                <label class="custom-control-label" for="idk-no">No</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex border-bottom justify-content-between">
                                        <small class="py-1 mr-3">Gives up easily</small>
                                        <div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" formControlName="giveUp"
                                                    class="custom-control-input" value=1>
                                                <label class="custom-control-label" for="give-up-yes">Yes</label>
                                            </div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" formControlName="giveUp"
                                                    class="custom-control-input" value=2>
                                                <label class="custom-control-label" for="give-up-no">No</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex border-bottom justify-content-between">
                                        <small class="py-1 mr-3">How much longer?</small>
                                        <div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" formControlName="howMuchLongerTally"
                                                    class="custom-control-input" value=1>
                                                <label class="custom-control-label"
                                                    for="how-much-longer-pencil-yes">Yes</label>
                                            </div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" formControlName="howMuchLongerTally"
                                                    class="custom-control-input" value=2>
                                                <label class="custom-control-label"
                                                    for="how-much-longer-pencil-no">No</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex border-bottom justify-content-between">
                                        <small class="py-1 mr-3">Needs directions repeated</small>
                                        <div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" formControlName="needsDirection"
                                                    class="custom-control-input" value=1>
                                                <label class="custom-control-label"
                                                    for="needs-direction-yes">Yes</label>
                                            </div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" formControlName="needsDirection"
                                                    class="custom-control-input" value=2>
                                                <label class="custom-control-label" for="needs-direction-no">No</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex border-bottom justify-content-between">
                                        <small class="py-1 mr-3">Glasses?</small>
                                        <div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" formControlName="glasses"
                                                    class="custom-control-input" value=1>
                                                <label class="custom-control-label" for="glasses-yes">Yes</label>
                                            </div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" formControlName="glasses"
                                                    class="custom-control-input" value=2>
                                                <label class="custom-control-label" for="glasses-no">No</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <!-- Your Observation Form -->
            <div class="col-12">
                <div class="card">
                    <h5 class="mb-0 text-purple">Observation Summary</h5>
                    <hr>
                    <div form="observationSummary" class="custom-form">
                        <div id="observation" class="rounded bg-theme-light py-3">
                            <div class="col-12 d-flex flex-column">
                                <label for="observationSummary">Write your observation (min 10 words). *</label>
                                <textarea class="custom-input" [(ngModel)]="comments"
                                    [ngClass]="{'border border-danger': comments.length<=10 }" rows="5"
                                    maxlength="20000"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Student Information Form -->
            <div class="col-12">
                <div class="card">
                    <h5 class="mb-0 text-purple">Student Information Form</h5>
                    <hr>
                    <form [formGroup]="studentInfo" class="custom-form">
                        <div id="observation" class="rounded bg-theme-light py-3">
                            <div class="col-12">
                                <label for="answer1">What are your feelings toward school and learning? *</label>
                                <textarea formControlName="answer1" rows="2" maxlength="10000"
                                [ngClass]="{'border border-danger': sf['answer1'].touched && sf['answer1'].invalid}" ></textarea>
                            </div>
                            <div class="col-12">
                                <label for="answer2">What is your easiest subject and why? *</label>
                                <textarea formControlName="answer2" rows="2" maxlength="10000"
                                [ngClass]="{'border border-danger': sf['answer2'].touched && sf['answer2'].invalid}"></textarea>
                            </div>
                            <div class="col-12">
                                <label for="answer3">What is your least favourite subject and why? *</label>
                                <textarea formControlName="answer3" rows="2" maxlength="10000"
                                [ngClass]="{'border border-danger': sf['answer3'].touched && sf['answer3'].invalid}"></textarea>
                            </div>
                            <div class="col-12">
                                <label for="answer4">Which skills are hardest for you or what do you struggle with the
                                    most in school? *</label>
                                <textarea formControlName="answer4" rows="2" maxlength="10000"
                                [ngClass]="{'border border-danger': sf['answer4'].touched && sf['answer4'].invalid}"></textarea>
                            </div>
                            <div class="col-12">
                                <label for="answer5">If you struggle in school, how does that make you feel? *</label>
                                <textarea formControlName="answer5" rows="2" maxlength="10000"
                                [ngClass]="{'border border-danger': sf['answer5'].touched && sf['answer5'].invalid}"></textarea>
                            </div>
                            <div class="col-12">
                                <label for="answer6">What would help you feel more comfortable and successful in
                                    school? *</label>
                                <textarea formControlName="answer6" rows="2" maxlength="10000"
                                [ngClass]="{'border border-danger': sf['answer6'].touched && sf['answer6'].invalid}"></textarea>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="col-12 mb-5">
                <div class="actions d-flex justify-content-center">
                    <button 
                        [ngClass]="{'grey' : studentObservation.invalid || studentInfo.invalid || comments.length<=10 }"
                        
                        class="theme-button green mr-3" data-toggle="modal"
                        (click)="completeButtonAction()">Complete Assessment</button>

                        <button 
                        class="theme-button green mr-3" data-toggle="modal"
                        data-target="#draftApointmentModal">Save Draft Observation</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="completeApointmentModal" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="completeApointmentModal" aria-hidden="true">
    <div class="modal-dialog">
        <form id="createDiagnosticianForm" class="custom-form" autocomplete="off">
            <div class="modal-content text-center light px-5 py-4">
                <h6 class="text-purple mb-3">Are you sure you want to Complete this assessment?</h6>
                <div class="action mt-3">
                    <button class="theme-button green mr-2" (click)="finalSubmitAppt()" data-dismiss="modal">Yes, Complete
                        this assessment</button>
                    <button class="theme-button grey" data-dismiss="modal">No</button>
                </div>
            </div>
        </form>
    </div>
</div>
<div class="modal fade" id="draftApointmentModal" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="draftApointmentModal" aria-hidden="true">
    <div class="modal-dialog">
        <form id="" class="custom-form" autocomplete="off">
            <div class="modal-content text-center light px-5 py-4">
                <h6 class="text-purple mb-3">Are you sure you want to draft this assessment?</h6>
                <div class="action mt-3">
                    <button class="theme-button green mr-2" (click)="draftSubmitAppt()" data-dismiss="modal">Yes, Save Draft Observation</button>
                    <button class="theme-button grey" data-dismiss="modal">No</button>
                </div>
            </div>
        </form>
    </div>
</div>
<div class="modal fade" id="viewDocumentsModal" data-keyboard="true" tabindex="-1" aria-labelledby="viewDocumentsModal"
    aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content light px-5 py-4">
            <div class="d-flex justify-content-end">
                <!-- Close button or icon -->
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <h5 class="text-center mb-4">Attached Documents</h5>
            <div class="d-flex flex-wrap justify-content-center">
                <p class="badge bg-theme-light border mr-2" *ngFor="let doc of documents">
                    <a [href]="appBaseUrl + doc.filePath" download="{{doc.fileName}}"
                    target="_blank"
                        class="d-block px-3 py-2 small text-dark">&#10515; Download {{doc.fileName}}</a>
                </p>
            </div>
        </div>
    </div>
</div>

<div class="modal fade show" id="paymentModal" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="paymentModal" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content light px-5 py-4">
            <h4 class="text-center">Payment Details</h4>
            <table class="mt-2 table-bordered small table-sm text-monospace">
                <tbody>
                    <tr>
                        <td>Total Amount</td>
                        <td>${{totalAmount}}</td>
                    </tr>
                    <tr>
                        <td>Collected Amount</td>
                        <td>${{paymentMade}}</td>
                    </tr>
                    <tr class="text-danger">
                        <td>Remaining Amount</td>
                        <td>${{remainingAmount}}</td>
                    </tr>
                </tbody>
            </table>
            <input type="number" placeholder="Enter Amount"  [(ngModel)]=paymentAmount id="bookingDeposit"
                class="custom-input my-4" required>

            <div class="action border-top pt-4 text-center">
                <a href="https://app.fluidpay.com/auth"
                    target="_blank" class="theme-button green mx-2">Payment Link</a>
                <button class="theme-button mx-2" data-dismiss="modal"
                [ngClass]="{'grey' : !validatePayment()}"
                    [disabled]=" paymentAmount > remainingAmount || paymentAmount==='' "
                    (click)="submitPayment()">Collect</button>
                <a href="#!" class="theme-button grey mx-2" data-dismiss="modal">No Payment</a>

            </div>
            <!-- <div class="custom-control custom-checkbox text-center my-4">
                <input type="checkbox" id="remaningAmount" class="custom-control-input" [(ngModel)]="paymentAmount">
                <label class="custom-control-label user-select-none" for="remaningAmount">I have Received remaining
                    ${{remainingAmount}}</label>
            </div> -->
            <!-- <div class="action text-center">
                <a href="#!" class="theme-button mx-2" (click)="closeModal()" data-dismiss="modal">Continue</a>
            </div> -->
        </div>
    </div>
</div>

<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-scale-multiple"></ngx-spinner>
